import { StoreBadges } from "@components/shared/StoreBadges";
import { ValueLine } from "@components/brand/ValueLine";

/** Closing call to action: title, one line, both store badges, on mist. */
export const AppCta = ({
  title,
  body,
  placement,
  headingAs: Heading = "h2",
}: {
  title: string;
  body: string;
  placement: string;
  /** `h1` when the CTA is the page itself, as on `/app`. */
  headingAs?: "h1" | "h2";
}) => (
  <section className="relative overflow-hidden bg-mist py-20 md:py-28">
    <ValueLine
      animate={false}
      className="pointer-events-none absolute inset-x-0 bottom-0 h-[60%] w-full opacity-60 rtl:-scale-x-100"
    />
    <div className="container relative">
      <div className="max-w-2xl">
        <Heading className="display text-h2-sm md:text-h2">{title}</Heading>
        <p className="mt-4 max-w-prose text-body text-slate-600">{body}</p>
        <StoreBadges placement={placement} className="mt-8" />
      </div>
    </div>
  </section>
);
